import { Navigate } from 'react-router-dom';
import ProtectedRoute from "../layouts/ProtectedRoute";
import Dashboard from "../screens/dashboard/Dashboard";
import SignIn from "../screens/signin/SignIn";

const routes = [
	{
		path: '/',
		element: <ProtectedRoute><Dashboard /></ProtectedRoute>
	},
	{
		path: '/signin',
		element: <SignIn />
	},
	{
		path: '*',
		element: <ProtectedRoute><Dashboard /></ProtectedRoute>
	}
];

export default routes;
